import { useAppConfig } from "./AppConfig";
import { MessageProvider } from "./common/message-provider";
import { LoadingPageLayout } from "./layout/LoadingPageLayout";
import { MainPage } from "./pages/MainPage";
import { Box } from "@mui/material";
import * as React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";


export default function App() {
  const [appConfig, isLoading] = useAppConfig();

  return (
    <Box style={{ margin: 24 }}>
      {isLoading ? (
        <LoadingPageLayout>Loading Configuration</LoadingPageLayout>
      ) : (
        <BrowserRouter basename={appConfig.AppBase}>
          <MessageProvider>
            <Routes>
              <Route path="/" element={<MainPage />} />
            </Routes>
          </MessageProvider>
        </BrowserRouter>
      )}
    </Box>
  );
}
